import React, { useContext } from 'react';
import DateTimeFilterDropdownContent from '../DropdownContent/DateTimeFilterDropdownContent';
import { BaseFilterProps } from '../../common/BaseFilter';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { t } from '../../../../../types/translation/Translator';
import dayjs from 'dayjs';
import { CalendarIcon } from '../../../../icons/Calendar/CalendarIcon';
import { UserContext } from '../../../../../context/UserContext';
import FilterDropdown from '../../common/FilterDropdown';

interface DateTimeFilterContentProps {
  props: BaseFilterProps;
}

export const DateTimeFilterContent = ({ props }: DateTimeFilterContentProps) => {
  const { locale } = useContext(UserContext);

  const text = (props: BaseFilterProps) => {
    if (!props.filterProps.timeFrame) return t(TranslationKey.dateAndTime).singular.label;

    return `${new Date(props.filterProps.timeFrame.start).toLocaleDateString(locale)} - ${new Date(
      props.filterProps.timeFrame.end,
    ).toLocaleDateString(locale)}`;
  };

  const toInnerContent = (props: BaseFilterProps) => {
    return <div className='py-1 text-sm text-gray-500'>{text(props)}</div>;
  };

  const handleChange = (props: BaseFilterProps, start?: Date, end?: Date) => {
    if (!start || !end) {
      props.filterProps.timeFrame = undefined;
    } else {
      if (!props.filterProps.timeFrame) props.filterProps.timeFrame = { start: start, end: end };
      props.filterProps.timeFrame = { start: dayjs(start).startOf('day').toDate(), end: end };
    }
    props.setFilterProps({ ...props.filterProps });
  };

  return (
    <>
      <p className='mb-1 text-sm text-gray-900'>{`${t(TranslationKey.dateAndTime).singular.label}`}</p>
      <FilterDropdown
        width={'fit-content'}
        icon={<CalendarIcon />}
        innerContent={toInnerContent(props)}
        dropdownContent={
          <DateTimeFilterDropdownContent
            key={'dateTimeFilterContent'}
            timeFrame={props.filterProps.timeFrame}
            color={'black'}
            onChange={(start, end) => handleChange(props, start, end)}
          />
        }
      />
    </>
  );
};
